import {FormApplicantIncome} from "./FormApplicantIncome";
import {FormApplicantFinancialOperations} from "./FormApplicantFinancialOperations";
import {FormApplicationIncomeMobile} from "./FormApplicationIncomeMobile";
import {FormApplicantFinancialOperationsMobile} from "./FormApplicantFinancialOperationsMobile";
import {Desktop, LandscapePhonesAndSmaller, LandscapeTablet} from "../../../utils/breakpoints";
import { useIntl } from "react-intl";
import { useEffect } from "react";
import {useState} from 'react';
import ClockLoader from "react-spinners/ClockLoader";
interface FinancialInfoContainerProps {
    errors?: any;
    values?: any;
    
}

export function FinancialInfoContainer(props: FinancialInfoContainerProps) {
    const {errors, values} = props;
    const intl = useIntl();
    const [isLoading, setIsLoading] = useState(true);
    const [popup, setPopup] = useState("close");
    useEffect(() => {
        setIsLoading(true);
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 1000);
        return () => clearTimeout(timer);
    }, []);
    useEffect(() => {
        if (errors && Object.keys(errors).length > 0) {
            console.log('Campos obligatorios con error (info financiera):', Object.keys(errors));
        }
    }, [errors]);
    const renderTitle = () => {
        return (
            <div className="financial-step-title">
                <ClockLoader id='spinner' color="#4FAE32" loading={isLoading} size={56} />
                <h1 className="title-red">{intl.formatMessage({id: "form_financial_information_title"})}</h1>
                <h1 className="subtitle-medium">{intl.formatMessage({id: "form_credit_information_subtitle"})}</h1>
            </div>
        )
    }

    return (
        <>
            <Desktop>
                <div className="financial-info-page">
                    {renderTitle()}
                    <div className="financial-info-layout">
                        <section className="financial-card">
                            <FormApplicantIncome errors={errors} values={values}/>
                        </section>
                        <section className="financial-card">
                            <FormApplicantFinancialOperations errors={errors} values={values}/>
                        </section>
                    </div>
                </div>
            </Desktop>
            <LandscapeTablet>
                <div className="financial-info-page">
                {renderTitle()}
                    <div className="financial-info-layout">
                        <section className="financial-card">
                            <FormApplicantIncome errors={errors} values={values}/>
                        </section>
                        <section className="financial-card">
                            <FormApplicantFinancialOperations errors={errors} values={values}/>
                        </section>
                    </div>
                </div>
            </LandscapeTablet>
            <LandscapePhonesAndSmaller>
                <>
                {renderTitle()}
                    <FormApplicationIncomeMobile errors={errors} values={values}/>
                    <FormApplicantFinancialOperationsMobile errors={errors} values={values}/>
                </>
            </LandscapePhonesAndSmaller>
        </>
    )
}
